import EventsSearchList from './EventsSearchList';

export default EventsSearchList;
